module.exports = __webpack_public_path__ + "img/gc_country_flag_mx.22bbff50.svg";